<template>
  <div>
    <MenuLeft :show="showLeft" @show-menu="left_show"></MenuLeft>
    <MenuRight :show="showRight" @show-menu="right_show"></MenuRight>
    <header class="mui-bar mui-bar-nav">
      <slot name="title">
        <h1 class="mui-title">{{ title }}</h1>
      </slot>
      <slot name="left" v-if="$route.name !== 'Login'">
        <a class="mui-action-menu mui-icon mui-icon-bars mui-pull-left" @click="left_show" v-if="$route.name === 'Index'"></a>
        <a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left" @click="back" v-else></a>        
      </slot>
      <slot name="right" v-if="$route.name === 'Index'">
        <a id="setting" class="mui-icon mui-icon-gear mui-pull-right" @click="right_show" v-if="$route.name === 'Index'"></a>        
      </slot>
    </header>
  </div>
</template>

<script>
  import MenuLeft from "./MenuLeft";
  import MenuRight from "./MenuRight";
  export default {
    name: "MuiHeader",
    data() {
      return {
        showLeft: false,
        showRight: false
      };
    },
    components: {
      MenuLeft,
      MenuRight
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      left_show() {
        this.showLeft = !this.showLeft;
      },
      right_show() {
        this.showRight = !this.showRight;
      }
    },
    computed: {
      title() {
        return this.$store.state.global.title;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/MuiHeader.vue